import styled from "styled-components";
import { globalScrollbarStyling } from "oolib/dist/v2/themes/globalStyles";

/* A vertical scroll area with the platform's scrollbar (the same
   globalScrollbarStyling the sidebar layout and reports use). The chat's
   left list and right references pane render through this; the centre
   column gets it from SidebarLayoutV2's contentScrollbarStyling prop. */
export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  ${globalScrollbarStyling}
`;

export const TopFadeOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4rem;
  background: linear-gradient(white 0%, transparent 100%);
  pointer-events: none;
  z-index: 5;
`;

// radial gradient
export const BottomOverlay = styled.div`
  position: fixed;
  z-index: -1;

  height: 100vh;
  width: 100%;

  background-image: radial-gradient(circle at bottom, #e3efff 5%, #ffffff 70%);
`;


export const SearchAreaOverlay = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 12rem; // Adjust this height based on your search box and padding
  background-image: radial-gradient(circle at bottom, #e3efff 5%, #ffffff 70%);
  z-index: 99; // Higher than content but lower than your search box
  pointer-events: none; // Allows clicking through to elements below
`;